import Quill from 'quill';
import { filePickerHelperViewActions } from 'src/components/10-atoms/file-picker/hooks/useFilePicker';
import { FileType } from 'src/components/10-atoms/file-picker/types';
import { snackbarHelperActions } from 'src/components/20-helper-views/snackbar/useSnackbar';
import { stripHTMLTags } from 'src/utils/html';
import Img2TxtLoader from './Img2TxtLoader';
class Img2TxtConverter {
    quill;
    options;
    constructor(quill, options) {
        this.quill = quill;
        this.options = options;
        if (typeof this.options.convert !== 'function') {
            console.warn('[Missing config] `convert` function is required');
        }
    }
    async selectLocalImage() {
        this.quill.focus();
        const pickedFiles = await filePickerHelperViewActions.pick({
            allowedTypes: [FileType.IMAGES, FileType.PDF],
            allowMultiple: false,
        });
        const file = pickedFiles?.[0];
        file && this.readAndUploadFile(file.file);
    }
    readAndUploadFile(file) {
        if (!file) {
            return;
        }
        const fileReader = new FileReader();
        this.quill.insertText(this.quill.getSelection(true).index, '\n');
        const range = this.quill.getSelection(true);
        fileReader.addEventListener('load', () => {
            const base64ImageSrc = fileReader.result;
            const placeholderBlot = this.insertPlaceholderImage(range, base64ImageSrc);
            this.options.convert(file).then(text => {
                const isRemoved = this.removePlaceholderImage(placeholderBlot);
                if (isRemoved) {
                    this.insertConvertedText(range, text);
                }
            }, error => {
                const isRemoved = this.removePlaceholderImage(placeholderBlot);
                if (isRemoved) {
                    console.warn(error);
                    snackbarHelperActions.show({
                        variant: 'NEGATIVE',
                        message: 'Failed to convert the image to text',
                    });
                }
            });
        }, false);
        fileReader.readAsDataURL(file);
    }
    insertPlaceholderImage(range, url) {
        const index = range?.index ?? this.quill.getLength();
        this.quill.insertEmbed(index, Img2TxtLoader.blotName, `${url}`, Quill.sources.USER);
        const [placeholderBlot] = this.quill.getLine(index);
        return placeholderBlot;
    }
    insertConvertedText(range, text) {
        const index = range?.index ?? this.quill.getLength();
        this.quill.getModule('pasteHandler')?.pasteHTMLSnippet(range, text);
        this.quill.setSelection(index + stripHTMLTags(text || '').length, Quill.sources.USER);
    }
    removePlaceholderImage(placeholderBlot) {
        const index = this.quill.getIndex(placeholderBlot);
        if (index === -1) {
            return false;
        }
        this.quill.deleteText(index, 1, Quill.sources.USER);
        return true;
    }
}
export default Img2TxtConverter;
